import { FunctionComponent } from 'react';
import {
	Select,
	SelectOptionType,
} from '@montel/montelpro-shared-components-v2';
import { useGlobalContext } from 'components/common/GlobalContext/GlobalContext';

interface CountrySelectProps {
	value: string | null;
	onChange: (countryCode: string) => void;
	onBlur?: () => void;
	required?: boolean;
	errorMessage?: string;
	label?: string;
	loading?: boolean;
	className?: string;
}

export const CountrySelect: FunctionComponent<CountrySelectProps> = ({
	value,
	onChange,
	onBlur,
	required = false,
	label = 'Country',
	loading = false,
	errorMessage,
	className,
}) => {
	const { countries } = useGlobalContext();

	const options =
		countries?.map((country) => ({
			value: country.twoLetterIsoCode,
			label: country.name,
		})) || [];

	options.sort((a, b) => a.label.localeCompare(b.label));

	return (
		<Select
			className={className}
			label={label}
			required={required}
			disabled={loading}
			name="country"
			options={options}
			value={{
				value: value || '',
				label:
					options.find((option) => option.value === value)?.label ||
					'',
			}}
			onChange={(option: SelectOptionType) => {
				const selectedCountry = countries.find(
					(country) => country.twoLetterIsoCode === option?.value,
				);
				if (selectedCountry) {
					onChange(selectedCountry.twoLetterIsoCode);
				}
			}}
			onBlur={onBlur}
			errorMessage={errorMessage}
			placeholder={loading ? 'Loading...' : 'Select a country'}
		/>
	);
};

export default CountrySelect;
